import { render } from "./SuoFang.vue?vue&type=template&id=4211f523"
import script from "./SuoFang.vue?vue&type=script&lang=js"
export * from "./SuoFang.vue?vue&type=script&lang=js"

import "./SuoFang.vue?vue&type=style&index=0&id=4211f523&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__